import { useState, useEffect, useCallback } from 'react';

const PREFIX = 'PAGINATION-';

function getStored(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function setStored(key, payload) {
  localStorage.setItem(PREFIX + key, JSON.stringify(payload));
}

export function clearPagination(key) {
  localStorage.removeItem(PREFIX + key);
}

export default function usePagination(storageKey, defaults = { page: 0, limit: 20 }) {
  const saved = getStored(storageKey);
  const initialPage = saved.page ?? defaults.page;
  const initialLimit = saved.limit ?? defaults.limit;

  const [page, setPageState] = useState(initialPage);
  const [limit, setLimitState] = useState(initialLimit);
  const offset = page * limit;

  useEffect(() => {
    setStored(storageKey, { page, limit });
  }, [storageKey, page, limit]);

  const setPage = useCallback((newPage) => {
    setPageState(newPage);
  }, []);

  const setLimit = useCallback((newLimit) => {
    setLimitState(newLimit);
    setPageState(0);
  }, []);

  return { page, limit, offset, setPage, setLimit, clear: () => clearPagination(storageKey) };
}
